// The admin chat log for every chat (Ryan, 2026-10-06, Lane 1391): each turn
// goes to chat capture, which writes the row the admin export reads, with the
// chat it came from. Same gates as the Home chat: the company's chat capture
// switch, a signed-in user, and the user's consent (or always-on capture).
// Fire and forget, after the answer (Rule 108): never in the turn's way.
import { evaluateMessage } from '../api/chatCapture';
import { hasConsent } from './captureConsent';

export function captureAllowed(auth) {
  const { chatCaptureEnabled, alwaysOnCaptureEnabled, user } = auth || {};
  return Boolean(chatCaptureEnabled) && user?.user_id != null
    && (Boolean(alwaysOnCaptureEnabled) || hasConsent(user.user_id) === true);
}

export function logChatTurn(auth, chatSurface, { question, answer, conversationId, clientTurnId }) {
  if (!chatSurface || !question || !captureAllowed(auth)) return;
  evaluateMessage(question, null, {
    assistantResponse: answer || null, conversationId, clientTurnId, chatSurface,
  }).catch(() => {});
}
